import cx from "classnames";
import React, { CSSProperties } from "react";
import style from "./tabs.module.scss";
import styles from "./tabs.module.scss";

interface ITabs {
  tabs: {
    title: React.ReactNode;
    value: string;
    icon?: React.ReactNode;
  }[];
  selected: string;
  setSelected: (value: string) => void;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const Tabs = (props: ITabs) => {
  const onSelectTab = (value: string) => {
    props.setSelected(value);
  };

  return (
    <div className={cx(styles.tabs, props.className)} style={props.style} id={props.htmlId}>
      {props.tabs.map((elem, index) => (
        <p
          key={index}
          onClick={() => onSelectTab(elem.value)}
          className={cx(style.item, elem.value === props.selected && style.active)}
        >
          {elem.icon}
          <span>{elem.title}</span>
        </p>
      ))}
    </div>
  );
};
